const OCCUPATION_THRESHOLD_LOW = 50
const OCCUPATION_THRESHOLD_HIGH = 80

export const CAPACITY_MODE = Object.freeze({
    REDUCED: 'RED',
    CONVENTIONAL: 'CONV',
    EXTENDED: 'AMP',
})

const CAPACITY_MODE_LABEL = Object.freeze({
    [CAPACITY_MODE.REDUCED]: 'Reduzida',
    [CAPACITY_MODE.CONVENTIONAL]: 'Convencional',
    [CAPACITY_MODE.EXTENDED]: 'Ampliada',
})

/**
 * Retorna a capacidade que deve ser usada como denominador no cálculo de ocupação.
 *
 * Why: o ambiente tem três valores (reduced/capacity/extended) e um modo ativo
 * (`capacity_mode`) que decide qual vale. O backend já expõe `active_capacity`
 * via accessor; esta função serve como fallback robusto quando a resposta
 * simplificada traz só `capacity` ou quando o modo não foi definido.
 */
export function getActiveCapacity(ambience) {
    if (!ambience) return 0
    if (ambience.active_capacity != null) return ambience.active_capacity

    switch (ambience.capacity_mode) {
        case CAPACITY_MODE.REDUCED:
            return ambience.reduced_capacity ?? ambience.capacity ?? 0
        case CAPACITY_MODE.EXTENDED:
            return ambience.extended_capacity ?? ambience.capacity ?? 0
        default:
            return ambience.capacity ?? 0
    }
}

export function getCapacityModeLabel(capacityMode) {
    return CAPACITY_MODE_LABEL[capacityMode] || null
}

export function getOccupationPercentage(ambience, occupation) {
    const capacity = getActiveCapacity(ambience)
    if (!capacity || !occupation?.students) return 0
    return Math.round((occupation.students / capacity) * 100)
}

export function getOccupationColor(ambience, occupation) {
    if (!occupation) return 'grey'
    const percentage = getOccupationPercentage(ambience, occupation)
    if (percentage <= OCCUPATION_THRESHOLD_LOW) return 'success'
    if (percentage <= OCCUPATION_THRESHOLD_HIGH) return 'warning'
    return 'error'
}

export function getBalanceColor(balance) {
    if (balance == null) return 'grey'
    if (balance > 0) return 'success'
    if (balance === 0) return 'info'
    return 'error'
}
